import React, { memo } from "react";
import { Tooltip } from "@design-system/Tooltip/Tooltip";
import { Row } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { TransactionListItem } from "@common/schemas/transaction.schema";
import { ViewTableCell } from "@design-system/ViewTable/ViewTableCell";
import { useIsDateLocked } from "@hooks/useIsDateLocked";
import { toDisplayDateOnly } from "@helpers/date";
import { LockIcon } from "@icons";
import styles from "./LockCell.module.scss";

interface Props {
    row: Row<ViewTableFeatures, TransactionListItem>;
}

export const LockCell = memo(({ row }: Props) => {
    const transaction: TransactionListItem = row.original;
    const isLocked = useIsDateLocked(
        transaction.entity.id,
        toDisplayDateOnly(transaction.dateOnly ?? transaction.date),
    );

    if (!isLocked) {
        return null;
    }

    return (
        <ViewTableCell>
            <Tooltip
                side="top"
                content={
                    <>
                        This transaction is locked.
                        <br />
                        To unlock, go to <strong>Settings &gt; Locks</strong>
                    </>
                }
            >
                <span
                    className={styles.value}
                    data-testid="transaction-list-item-lock"
                >
                    <LockIcon className="icon-color-current" />
                </span>
            </Tooltip>
        </ViewTableCell>
    );
});
LockCell.displayName = "LockCell";
